import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _excluded = ["children"];

/** @jsx jsx */
import { css, jsx, useTheme } from '@emotion/react';
import { optimizeLegibility } from '@flowio/react-theme';
import React from 'react';

var buttonStyle = function buttonStyle(theme) {
  return /*#__PURE__*/css(theme.breakpoints.mq({
    fontFamily: theme.typography.body.fontFamily,
    fontSize: theme.typography.body.fontSize,
    fontWeight: theme.typography.body.fontWeight
  }), _objectSpread(_objectSpread({}, optimizeLegibility()), {}, {
    display: 'inline-block',
    padding: 0,
    margin: 0,
    background: 'none',
    border: 0,
    borderRadius: 0,
    boxShadow: 'none',
    color: theme.color.text.button.link.base,
    lineHeight: '2rem',
    textAlign: theme.direction === 'ltr' ? 'left' : 'right',
    textDecoration: 'underline',
    appearance: 'none',
    cursor: 'pointer',
    '&:active': {
      color: theme.color.text.button.link.active
    },
    '&:focus': {
      outline: 0,
      boxShadow: theme.shadow.focusRing
    }
  }), process.env.NODE_ENV === "production" ? "" : ";label:buttonStyle;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0xpbmtCdXR0b24udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVF3RCIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9MaW5rQnV0dG9uLnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuXG5pbXBvcnQgeyBjc3MsIGpzeCwgdXNlVGhlbWUgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyBvcHRpbWl6ZUxlZ2liaWxpdHkgfSBmcm9tICdAZmxvd2lvL3JlYWN0LXRoZW1lJztcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgdHlwZSB7IFNlcmlhbGl6ZWRTdHlsZXMsIFRoZW1lIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHR5cGUgeyBMaW5rQnV0dG9uUHJvcHMgfSBmcm9tICcuLi90eXBlcyc7XG5cbmNvbnN0IGJ1dHRvblN0eWxlID0gKHRoZW1lOiBUaGVtZSk6IFNlcmlhbGl6ZWRTdHlsZXMgPT4gY3NzKFxuICB0aGVtZS5icmVha3BvaW50cy5tcSh7XG4gICAgZm9udEZhbWlseTogdGhlbWUudHlwb2dyYXBoeS5ib2R5LmZvbnRGYW1pbHksXG4gICAgZm9udFNpemU6IHRoZW1lLnR5cG9ncmFwaHkuYm9keS5mb250U2l6ZSxcbiAgICBmb250V2VpZ2h0OiB0aGVtZS50eXBvZ3JhcGh5LmJvZHkuZm9udFdlaWdodCxcbiAgfSksXG4gIHtcbiAgICAuLi5vcHRpbWl6ZUxlZ2liaWxpdHkoKSxcbiAgICBkaXNwbGF5OiAnaW5saW5lLWJsb2NrJyxcbiAgICBwYWRkaW5nOiAwLFxuICAgIG1hcmdpbjogMCxcbiAgICBiYWNrZ3JvdW5kOiAnbm9uZScsXG4gICAgYm9yZGVyOiAwLFxuICAgIGJvcmRlclJhZGl1czogMCxcbiAgICBib3hTaGFkb3c6ICdub25lJyxcbiAgICBjb2xvcjogdGhlbWUuY29sb3IudGV4dC5idXR0b24ubGluay5iYXNlLFxuICAgIGxpbmVIZWlnaHQ6ICcycmVtJyxcbiAgICB0ZXh0QWxpZ246IHRoZW1lLmRpcmVjdGlvbiA9PT0gJ2x0cicgPyAnbGVmdCcgOiAncmlnaHQnLFxuICAgIHRleHREZWNvcmF0aW9uOiAndW5kZXJsaW5lJyxcbiAgICBhcHBlYXJhbmNlOiAnbm9uZScsXG4gICAgY3Vyc29yOiAncG9pbnRlcicsXG4gICAgJyY6YWN0aXZlJzoge1xuICAgICAgY29sb3I6IHRoZW1lLmNvbG9yLnRleHQuYnV0dG9uLmxpbmsuYWN0aXZlLFxuICAgIH0sXG4gICAgJyY6Zm9jdXMnOiB7XG4gICAgICBvdXRsaW5lOiAwLFxuICAgICAgYm94U2hhZG93OiB0aGVtZS5zaGFkb3cuZm9jdXNSaW5nLFxuICAgIH0sXG4gIH0sXG4pO1xuXG5jb25zdCBMaW5rQnV0dG9uOiBSZWFjdC5GQzxMaW5rQnV0dG9uUHJvcHM+ID0gKHtcbiAgY2hpbGRyZW4sXG4gIC4uLnVuaGFuZGxlZFByb3BzXG59KSA9PiB7XG4gIGNvbnN0IHRoZW1lID0gdXNlVGhlbWUoKTtcbiAgcmV0dXJuIChcbiAgICA8YnV0dG9uXG4gICAgICB7Li4udW5oYW5kbGVkUHJvcHN9XG4gICAgICBjc3M9e2J1dHRvblN0eWxlKHRoZW1lKX1cbiAgICAgIHR5cGU9XCJidXR0b25cIj5cbiAgICAgIHtjaGlsZHJlbn1cbiAgICA8L2J1dHRvbj5cbiAgKTtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IExpbmtCdXR0b247XG4iXX0= */");
};

var LinkButton = function LinkButton(_ref) {
  var children = _ref.children,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  var theme = useTheme();
  return jsx("button", _extends({}, unhandledProps, {
    css: buttonStyle(theme),
    type: "button"
  }), children);
};

export default LinkButton;